import {
  take,
  fork,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';
import { failMiniGames, successMiniGames } from '../actionCreators/miniGames';

import apiRoutes from '../../constants/apiRoutes';

function* getMiniGames(): any {
  try {
    const headers = {};
    const token = yield select(getToken);
    headers['x-access-token'] = JSON.stringify(token);

    const response = yield call(apiGet, 'REACT_APP_MINI_GAMES_URL', apiRoutes.GET_MINI_GAMES, { token }, headers);
    if (response.data?.minigames) {
      yield put(successMiniGames(response.data?.minigames));
    } else {
      yield put(failMiniGames(response?.statusText));
    }
  } catch (e) {
    yield put(failMiniGames(e));
  }
}

export default function* watchMiniGamesRequest() {
  while (true) {
    yield take([actionTypes.MINI_GAMES_REQUEST]);
    yield fork(getMiniGames);
  }
}
